export { default } from './Table';


//////////////////
// WEBPACK FOOTER
// ./~/veritone-widgets/~/@material-ui/core/esm/Table/index.js
// module id = 9vW6
// module chunks = 22